import { useCallback, useEffect, useRef, useState } from 'react'
import { Howl } from 'howler'
import { useHistory } from 'react-router-dom'
import { useElementEvent, useEvent } from '../hooks'

const crossfadeDuration = 3000
const volume = 1

const useShortSounds = (
  data,
  start,
  activeImg,
  setActiveImg,
  disableNavigation,
  arrowForthRef,
  pause,
  setPause,
  stopAll
) => {
  const [activeSoundLoaded, setActiveSoundLoaded] = useState(false)
  const [loadedSoundsCount, setLoadedSoundsCount] = useState(0)
  const [arrowNavDirection, setArrowNavDirection] = useState(null)

  let history = useHistory()

  const longSoundRef1 = useRef(data[0].longSound && data[0].longSound[0])
  const longSoundRef2 = useRef(data[0].longSound && data[0].longSound[1])
  const longSoundRef3 = useRef(data[0].longSound && data[0].longSound[2])
  const longSound = longSoundRef1.current
  const longSound2 = longSoundRef2.current
  const longSound3 = longSoundRef3.current

  const [longSoundStart, setLongSoundStart] = useState(longSound && longSound.start)
  const [longSoundEnd, setLongSoundEnd] = useState(longSound && longSound.end)

  const smallImageSeek = useRef(0)

  const [sounds] = useState(() =>
    data.map((item, i) =>
      item.audio
        ? new Howl({
            src: item.audio,
            html5: i > 5,
            volume: 1,
            preload: i <= 5,
            onload: () => {
              console.log(i)
              if (i <= 5) {
                setLoadedSoundsCount((prev) => prev + 1)
              }
            },
          })
        : null
    )
  )

  useEffect(() => {
    if (loadedSoundsCount === 5) {
      setActiveSoundLoaded(true)
      console.log('5 small files loaded')
    }
  }, [loadedSoundsCount])

  const [sound2] = useState(() => {
    const textItem = data.find((item) => item.text)
    return textItem
      ? new Howl({
          src: textItem.audio,
          preload: false,
          html5: true,
          volume: 0,
          onload: () => {
            console.log('text sound loaded')
            // setTextSoundLoaded(true)
          },
        })
      : null
  })

  useEffect(() => {
    if (activeSoundLoaded && start) {
      sounds.forEach((sound, i) => {
        if (i > 4 && sound) {
          sound.load()
        }
      })
      if (sound2) {
        sound2.load()
      }
    }
  }, [activeSoundLoaded, start, sounds, sound2])

  const [stopLoop, setStopLoop] = useState(false)
  const timeForLoopSet = useRef(false)

  useEffect(() => {
    return () => {
      console.log('unmount short sounds', window.timerId)
      clearTimeout(window.timerId)
      clearTimeout(window.loopId)
      clearTimeout(window.onlyImgChangeId)
      clearTimeout(window.stopLoopId)
      // TODO: Back to rooms: need to disable short sound
    }
  }, [])

  const redirectToRoom = (activeImage) => {
    let room = 'welcome'
    if (activeImage === 19) {
      //honey
      room = 'salt'
    } else if (activeImage === 22) {
      // watchmaker
      room = 'wool'
    } else if (activeImage === 25) {
      // shepherd
      room = 'watchmaker'
    } else if (activeImage === 26) {
      //wool
      room = 'lighthouse'
    } else if (activeImage === 30 && !!sound2) {
      // lighthouse
      room = 'mine'
    } else if (activeImage === 30) {
      // mine
      room = 'honey'
    }
    history.push(process.env.NODE_ENV === 'production' ? `/chapter?name=${room}` : `/chapter?name=${room}`)
    // else if (activeImage === 28) { // salt
  }

  const startPlay = (enteringInstance, disableAutoPlay) => {
    if (enteringInstance) {
      console.log(enteringInstance, enteringInstance._duration, activeImg)
      if (enteringInstance._duration) {
        // Fade in entering instance
        enteringInstance.fade(0, volume, crossfadeDuration)
        enteringInstance.play()
        if (!disableAutoPlay) {
          autoNextPlay(enteringInstance)
        }
      }
    }
  }

  const crossfadedLoop = (enteringInstance, leavingInstance) => {
    if (enteringInstance) {
      // Fade in entering instance
      enteringInstance.fade(0, volume, crossfadeDuration)
      enteringInstance.play()

      // Wait for the audio end to fade out entering instance
      // white fading in leaving instance
      window.loopId = setTimeout(() => {
        enteringInstance.fade(volume, 0, crossfadeDuration)
        crossfadedLoop(leavingInstance, enteringInstance)
      }, enteringInstance._duration * 1000 - crossfadeDuration)
    }
  }

  useEffect(() => {
    if (data[activeImg]?.text) {
      console.log(data[activeImg]?.text, 'loop')
      if (!timeForLoopSet.current) {
        window.stopLoopId = setTimeout(() => {
          setStopLoop(true)
          timeForLoopSet.current = true
        }, data[0].textDuration)
      }

      if (stopLoop) {
        console.log('stop loop', sounds[activeImg], activeImg)
        setActiveImg(activeImg + 1)
        clearTimeout(window.loopId)

        // for Wool only
        if (activeImg === 26) {
          redirectToRoom(26)
          stopPrevSound(activeImg - 1)
        }
      } else {
        console.log('loop 1 again')
        crossfadedLoop(sounds[activeImg], sound2)
      }
    }
  }, [activeImg, data, stopLoop, timeForLoopSet])

  const autoNextPlay = (leavingInstance, timeout) => {
    const id = setTimeout(() => {
      console.log('auto works')
      leavingInstance.fade(volume, 0, crossfadeDuration)
      if (activeImg === data.length - 1) {
        console.log('the end')
        setTimeout(() => {
          sounds.forEach((sound) => sound && sound.unload())
          redirectToRoom(activeImg)
        }, crossfadeDuration / 2)
      } else {
        setActiveImg(activeImg + 1)
      }
    }, timeout || leavingInstance._duration * 1000 - crossfadeDuration)
    console.log('test auto', id)
    clearTimeout(window.timerId)
    window.timerId = id
  }

  const changeImgWithNoSoundChange = (leavingInstance, thirdSoundImgsCount) => {
    console.log('test first change img')
    window.onlyImgChangeId = setTimeout(() => {
      setActiveImg(activeImg + 1)
    }, (leavingInstance._duration * 1000) / thirdSoundImgsCount - crossfadeDuration)
  }

  const stopPrevSound = useCallback(
    (prevImg) => {
      // prevSoundActive.current = Howler._howls.find((howl) => !!Object.keys(howl._endTimers)[0])
      console.log(prevImg, sounds[prevImg], 'stop prev')
      if (prevImg !== null && sounds[prevImg]) {
        sounds[prevImg].fade(1, 0, crossfadeDuration)
        setTimeout(() => {
          sounds[prevImg].stop()
        }, crossfadeDuration)
      }
    },
    [crossfadeDuration]
  )

  const getLongSoundValues = useCallback(() => {
    let longSoundStart = longSound && longSound.start
    let longSoundEnd = longSound && longSound.end
    if (longSound2) {
      if (activeImg > longSoundEnd) {
        longSoundStart = longSound2.start
        longSoundEnd = longSound2.end
      }
    }
    if (longSound3) {
      if (activeImg > longSoundEnd) {
        longSoundStart = longSound3.start
        longSoundEnd = longSound3.end
      }
    }
    setLongSoundStart(longSoundStart)
    setLongSoundEnd(longSoundEnd)
  }, [longSound, longSound2, longSound3, activeImg])

  useEffect(() => {
    if (longSoundStart) {
      getLongSoundValues()
    }
  }, [getLongSoundValues, longSoundStart])

  useEffect(() => {
    if (data[activeImg] && data[activeImg].short) {
      console.log(sounds[longSoundStart].seek())
      smallImageSeek.current = sounds[longSoundStart].seek()
    }
  }, [data, activeImg, longSoundStart, longSoundEnd])

  const onPauseClick = (pauseValue) => () => {
    let image = activeImg
    if (data[activeImg].short && activeImg !== longSoundStart) {
      image = longSoundStart
    }
    const currentPosition = sounds[image].seek()
    const soundDuration = sounds[image]._duration
    if (currentPosition > soundDuration - crossfadeDuration) {
      console.log(currentPosition, pauseValue)
      if (pauseValue) {
        setPause(true)
        clearTimeout(window.timerId)
        clearTimeout(window.stopLoopId)
        clearTimeout(window.loopId)
        clearTimeout(window.onlyImgChangeId)
        if (stopLoop) setStopLoop(false)
        if (timeForLoopSet.current) timeForLoopSet.current = false
        sounds[image].fade(1, 0, crossfadeDuration)
        setTimeout(() => {
          sounds[image].pause()
        }, crossfadeDuration)
      } else {
        setPause(false)
        sounds[image].seek(currentPosition - crossfadeDuration / 1000)
        sounds[image].fade(0, 1, crossfadeDuration)
        sounds[image].play()
        if (data[activeImg]?.short) {
          const longSoundsCount = longSoundEnd - longSoundStart + 1
          const oneImgDuration = (sounds[image]._duration * 1000) / longSoundsCount - crossfadeDuration
          const oneImageSeek = (currentPosition - smallImageSeek.current) * 1000 - crossfadeDuration
          console.log(activeImg, oneImgDuration, currentPosition, smallImageSeek.current, oneImageSeek)

          if (activeImg !== longSoundEnd) {
            window.onlyImgChangeId = setTimeout(() => {
              setActiveImg(activeImg + 1)
            }, oneImgDuration - oneImageSeek)
          } else if (activeImg === longSoundEnd) {
            autoNextPlay(sounds[longSoundStart], oneImgDuration - oneImageSeek)
          }
        } else if (data[activeImg]?.text) {
          window.stopLoopId = setTimeout(() => {
            setStopLoop(true)
            timeForLoopSet.current = true
          }, data[0].textDuration - currentPosition * 1000)
          window.loopId = setTimeout(() => {
            crossfadedLoop(sound2, sounds[activeImg])
          }, (sound2._duration - currentPosition) * 1000 - crossfadeDuration)
        } else {
          autoNextPlay(
            sounds[image],
            (soundDuration - currentPosition + crossfadeDuration / 1000) * 1000 - crossfadeDuration / 2
          )
        }
      }
    }
  }

  const onArrowNavClick = useCallback(() => {
    if (!disableNavigation && !pause) {
      // if (activeImg > 0 && e.keyCode === 37) {
      //   setArrowNavDirection('back')
      //   setActiveImg((prev) => prev - 1)
      // }
      if (activeImg < data.length) {
        setArrowNavDirection('forth')
        setActiveImg((prev) => prev + 1)
      }
    }
  }, [pause])

  const checkKey = useCallback(
    (e) => {
      if (!disableNavigation && !pause) {
        // if (activeImg > 0 && e.keyCode === 37) {
        //   setArrowNavDirection('back')
        //   setActiveImg((prev) => prev - 1)
        // }
        if (activeImg < data.length && e.keyCode === 39) {
          setArrowNavDirection('forth')
          setActiveImg((prev) => prev + 1)
        }
      }
    },
    [pause]
  )
  useEvent('keydown', checkKey)
  useElementEvent('click', onArrowNavClick, arrowForthRef)

  useEffect(() => {
    console.log(activeImg)
    if (arrowNavDirection) {
      console.log('changed manually', arrowNavDirection, data.length)

      if (longSoundStart && data[activeImg].short) {
        console.log('manually with long sound')
        clearTimeout(window.onlyImgChangeId)
        console.log(sounds[longSoundStart].seek())

        if (activeImg === longSoundEnd) {
          console.log('manually - long end')
          stopPrevSound(longSoundStart)
        }
      } else if (activeImg === data.length - 1) {
        console.log('manually - the end')
        sounds[activeImg].fade(1, 0, crossfadeDuration / 2)
        setTimeout(() => {
          sounds.forEach((sound) => sound && sound.unload())
          redirectToRoom(activeImg)
        }, crossfadeDuration / 4)
      } else {
        stopPrevSound(activeImg)
      }
      clearTimeout(window.timerId)
      clearTimeout(window.stopLoopId)
      clearTimeout(window.loopId)
      clearTimeout(window.onlyImgChangeId)
      if (stopLoop) setStopLoop(false)
      if (timeForLoopSet.current) timeForLoopSet.current = false
      setArrowNavDirection(null)
    }
  }, [arrowNavDirection, activeImg, data, setArrowNavDirection, longSoundStart, longSoundEnd])

  useEffect(() => {
    if (start && activeSoundLoaded && data[activeImg] && !data[activeImg].text) {
      console.log('start new', activeImg)
      longSound && console.log('long sound', longSoundStart, longSoundEnd)

      if (data[activeImg].short && activeImg !== longSoundEnd) {
        console.log('change only img')
        const longSoundsCount = longSoundEnd - longSoundStart + 1
        changeImgWithNoSoundChange(sounds[longSoundStart], longSoundsCount)
        if (activeImg === longSoundStart) {
          console.log('long sound start')
          startPlay(sounds[activeImg], true)
        }
      } else if (activeImg === longSoundEnd) {
        // one short sound duration
        const timeout =
          (sounds[longSoundStart]._duration * 1000) / (longSoundEnd - longSoundStart + 1) - crossfadeDuration / 2
        console.log('auto next - long end', timeout)
        autoNextPlay(sounds[longSoundStart], timeout)
      } else {
        console.log('start play')
        startPlay(sounds[activeImg])
      }
    }
  }, [start, data, activeSoundLoaded, activeImg, sounds, longSoundStart, longSoundEnd])

  return {
    shortSoundsLoaded: activeSoundLoaded,
    onPauseClick,
    sounds,
  }
}

export default useShortSounds
